import styled from 'styled-components';

export const StyledTrainingDetailAttendance = styled.div`
  padding: 12px 36px;
  max-height: 60vh;
  min-height: 40vh;
  overflow-y: auto;
  padding-bottom: 20px;

  .tda-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  > div {
    > .MuiTableContainer-root {
      min-height: calc(400px - 60px);
      max-height: calc(400px - 60px);
    }
  }
`;

export const StyledUserNameBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* &.name {
    justify-content: flex-start;
  } */

  > img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  > span {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }
`;
